// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__127QR","image":"Header_image__f_jhX","name":"Header_name__3bbPp","info":"Header_info__9sHkK","infoRow":"Header_infoRow__uBLp-"};